import { http } from '@/_services/http.service'

function filenameFromContentDisposition (contentDisposition) {
  const utf8Filename = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)

  if (utf8Filename) {
    return decodeURIComponent(utf8Filename[1].replace(/['"]/g, ''))
  }

  const filename = contentDisposition.match(/filename="?([^";]+)"?/i)

  if (filename) {
    return filename[1]
  }

  return null
}

export const documentService = {

  getDocuments () {

    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/document`, options)
            .then(response => response.json())
  },

  download (id) {

    const options = {
      method: 'GET'
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/document/${id}`, options).then(response => {
      if (!response.ok) {
        return response.text().then(errorText => {
          throw new Error(errorText || 'Network response was not ok')
        })
      }

      const contentType = response.headers.get('Content-Type') || ''

      if (contentType.indexOf('application/json') !== -1) {
        return response.json().then(errorData => {
          throw new Error(errorData.message || 'Document kon niet worden geopend')
        })
      }

      const filename = filenameFromContentDisposition(response.headers.get('Content-Disposition') || '')

      return response.blob().then(blob => {
        return {
          blob,
          filename
        }
      })
    })
  },

  destroy (id) {
    const options = {
      method: 'DELETE',
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/document/${id}`, options)
      .then(response => {
        if (!response.ok) {
          return response.json().then(errorData => {
            throw { status: response.status, ...errorData };
          });
        }
        return response.json();
      })
      .catch(error => {
        console.error('Error:', error);
        return { 
          error: true, 
          message: error.message || 'Er is iets fout gegaan, herlaad de pagina en probeer het opnieuw',
          details: error
        };
      });
  },

  postDocument (id, file, forPartner) {
    const formData = new FormData()
    formData.append('payload', file)
    formData.append('id', id)
    formData.append('partner', forPartner)

    const options = {
      method: 'POST',
      body: formData
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/document`, options)
            .then(response => response.json())

  }

}
